var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"collapse":_vm.isSidebarNavCollapse,"background-color":"#fff","text-color":"#333","active-text-color":"#4dbcff","default-active":_vm.currentMenu,"unique-opened":true}},[_c('DynamicMenu',{attrs:{"menuList":_vm.sidebarMenu}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5259a8be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/layout/component/main-content/sidebar-nav.vue
// module id = null
// module chunks = 